<template>
    <div class="message-list d-flex gap-10-px">
        <div v-if="showFolderPanel" class="folder-container">
            <div class="dm-folder-panel">
                <div class="folder-box">
                    <div class="folder-box-title">フォルダ（未読/総数）</div>

                    <button class="folder-action-btn" @click="splitFolder">最新状態に更新</button>
                    <button class="folder-action-btn" @click="newFolderMessage">新規フォルダ作成</button>
                    <button class="folder-action-btn" @click="openFolderMessage">フォルダ振り分け修正</button>

                    <div class="folder-list">
                        <template v-for="folder in data.folderCount" :key="folder.FolderID">
                            <button class="folder-item" :class="{ active: activeFolder == folder.FolderID }" @click="selectFolder(folder.FolderID)">
                                <span class="folder-name">
                                    <ans-tooltip-span :id="'folderName' + folder.FolderID" :value="folder.FolderName" :parentWidth="120" />
                                </span>
                                <span class="folder-count">{{
                                    dmMessageMode == 'receive' ? folder.UnreadCount + '/' + folder.TotalCount : folder.TotalCount
                                }}</span>
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100">
            <div
                v-for="message in filteredList"
                :key="message.ReceivedMessageNo"
                class="message-item"
                :class="[
                    { unread: message.ReadFLG == 0 && message.CancelFLG == 0 && dmMessageMode == 'receive' },
                    { 'bg-cancel': message.CancelFLG == 1 }
                ]"
                @click="openDetailMessage(message)"
            >
                <div class="message-header">
                    <span class="sender-name">
                        {{ message.MessageType == 2 ? message.ExternalName : message.UserName }}

                        <span v-if="isAll" class="status-badge" :class="renderClass(message.MessageType)">
                            {{ message.MessageTypeName }}
                        </span>
                        <span v-if="message.CancelFLG == 1" class="status-badge cancel"> 取消済 </span>
                    </span>

                    <span class="message-time">{{ renderTime(message.DisplayTime) }}</span>
                </div>

                <div class="message-subject">{{ message.Subject }}</div>
                <div class="message-preview">{{ message.Body }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import MessageDetail from '@/views/popupSearch/popup_MNG_DM_Message/childComponent/MessageDetail.vue';
import { showPopup } from '@/utils/popup';
import { markRaw } from 'vue';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    props: {
        list: { type: Array, required: true },
        folders: { type: Array },
        isAll: { type: Boolean, default: false },
        tab: { type: String, default: '' }
    },
    created() {
        this.activeFolder = 0;
    },
    data() {
        return {
            activeFolder: 0,
            folderMessage: []
        };
    },
    watch: {
        tab() {
            this.activeFolder = '';
            this.folderMessage = [];
        },
        dmMessageMode() {
            this.activeFolder = '';
            this.folderMessage = [];
        }
    },
    computed: {
        ...mapState('app', ['dmMessageMode', 'user']),
        ...mapState('MNG_DM_Message_Store', ['data']),
        showFolderPanel() {
            return this.tab === 'internal' || this.tab === 'external';
        },
        filteredList() {
            if (this.showFolderPanel) {
                return this.activeFolder ? this.folderMessage : this.list;
            }
            return this.list;
        }
    },
    methods: {
        ...mapMutations('app', ['setDmMessageMode', 'updatePopupConfig']),
        ...mapMutations('MNG_DM_Message_Store', ['setFolderManagement', 'setFolder', 'setFolderCount']),
        ...mapActions('MNG_DM_Message_Store', ['readMessage', 'listDM', 'getFolder', 'getFolderMessage', 'getFolderCount', 'syncFolderMessage']),
        renderTime(time) {
            if (!time) return '';

            const date = new Date(time);
            const now = new Date();

            const isSameDate = (d1, d2) => d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();

            const yesterday = new Date(now);
            yesterday.setDate(now.getDate() - 1);

            if (isSameDate(date, now)) {
                // Hôm nay -> hiển thị HH:mm
                return date.toLocaleTimeString('ja-JP', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            }

            if (isSameDate(date, yesterday)) {
                // Hôm qua
                return '昨日';
            }

            // Số ngày trước
            const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const startOfTarget = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            const diffDays = Math.floor((startOfToday - startOfTarget) / (1000 * 60 * 60 * 24));

            return `${diffDays}日前`;
        },
        renderClass(type) {
            switch (parseInt(type)) {
                case 1:
                    return 'internal';
                case 2:
                    return 'external';
                case 3:
                    return 'group';
                case 4:
                    return 'comment';
                case 5:
                    return 'system';
                default:
                    return '';
            }
        },
        openDetailMessage(message) {
            if (message.ReadFLG == 0 && this.dmMessageMode == 'receive' && message.MessageType != 2) {
                this.readMessage({
                    params: {
                        CompanyCD: this.user.company_cd,
                        MessageNo: message.ReceivedMessageNo
                    },
                    callback: () => {
                        this.listDM({
                            params: {
                                CompanyCD: this.user.company_cd,
                                UserID: this.user.EmployeeCD,
                                Mode: 1,
                                Keyword: this.data.Keyword,
                                TargetDate: this.data.TargetDate
                            }
                        });
                        if (this.showFolderPanel) {
                            this.getFolder({
                                params: {
                                    CompanyCD: this.user.company_cd,
                                    UserID: this.user.EmployeeCD,
                                    Mode: 1,
                                    Keyword: this.data.searchFolder.Keyword,
                                    FolderID: '',
                                    BoxType: this.dmMessageMode == 'receive' ? 0 : 1,
                                    MessageType: this.tab == 'internal' ? 0 : 1,
                                    ActiveFLG: 1
                                },
                                callback: (data) => {
                                    this.setFolder(data);
                                }
                            });
                        }
                    }
                });
            }
            if (message.MessageType == 4) {
                this.$router.push({ name: 'MNG_WorkReport001', query: { work_report: message.WorkReportID } });
                return;
            }
            showPopup({
                component: markRaw(MessageDetail),
                componentProps: {
                    message: message
                },
                title: 'メッセージ詳細',
                dimensions: {
                    width: '30%',
                    height: '60%'
                },
                classes: {
                    overlay: '',
                    wrapper: 'dm-popup-container-2',
                    header: 'color-header-popup',
                    title: 'text-white',
                    body: '',
                    footer: '',
                    closeButton: 'btn-custom'
                },
                isStillShowPopupBefore: true
            });
        },
        openFolderMessage() {
            this.getFolder({
                params: {
                    CompanyCD: this.user.company_cd,
                    UserID: this.user.EmployeeCD,
                    Mode: 1,
                    Keyword: this.data.searchFolder.Keyword,
                    FolderID: '',
                    BoxType: this.dmMessageMode == 'receive' ? 0 : 1,
                    MessageType: this.tab == 'internal' ? 0 : 1,
                    ActiveFLG: 1
                },
                callback: (data) => {
                    this.setFolder(data);
                    this.setFolderManagement(true);
                    this.setDmMessageMode('group');
                    this.updatePopupConfig({ title: 'フォルダー一覧' });
                    this.updatePopupConfig({
                        dimensions: {
                            width: '50%',
                            height: '80%'
                        }
                    });
                }
            });
        },
        newFolderMessage() {
            this.setFolderManagement(true);
            this.setDmMessageMode('groupDetail');
            this.updatePopupConfig({ title: 'フォルダ振り分け設定' });
            this.updatePopupConfig({
                dimensions: {
                    width: '50%',
                    height: '80%'
                }
            });
        },
        splitFolder() {
            this.syncFolderMessage({
                params: {
                    CompanyCD: this.user.company_cd
                },
                callback: () => {
                    this.getFolderCount({
                        params: {
                            CompanyCD: this.user.company_cd,
                            UserID: this.user.EmployeeCD,
                            BoxType: this.dmMessageMode == 'receive' ? 0 : 1,
                            MessageType: this.tab == 'internal' ? 0 : 1
                        },
                        callback: (data) => {
                            this.setFolderCount(data);
                        }
                    });
                }
            });
        },
        selectFolder(folderID) {
            this.activeFolder = folderID;
            this.getFolderMessage({
                params: {
                    CompanyCD: this.user.company_cd,
                    UserID: this.user.EmployeeCD,
                    FolderID: folderID,
                    Mode: this.dmMessageMode == 'receive' ? 1 : 2,
                    MessageType: this.tab == 'internal' ? 0 : 1
                },
                callback: (data) => {
                    this.folderMessage = data;
                }
            });
        }
    }
};
</script>
